import { Permission } from "models/Permission";
import { AppStore } from "App/Store";

export const allowPlaylistCreate = (store: AppStore) => {
  const { allowTables } = store.UserToken;
  for (const allowTable of allowTables) {
    const permission = new Permission(allowTable.allow.split(""));
    switch (allowTable.table) {
      case "playlist":
        if (
          !permission.isUserReadable() ||
          !permission.isUserEditable() ||
          !permission.isUserWritable() ||
          !permission.isGroupReadable() ||
          !permission.isGroupEditable() ||
          !permission.isOtherWritable()
        ) {
          return false;
        }
        break;

      case "playlist_title":
        if (!permission.isUserReadable() || !permission.isUserEditable()) {
          return false;
        }
        break;
      case "playlist_users_relation":
        if (!permission.isUserReadable() || !permission.isUserEditable()) {
          return false;
        }
        break;
      default:
        break;
    }
  }
  return true;
};
